import { render, staticRenderFns } from "./NewUtente.vue?vue&type=template&id=46b664a0&"
import script from "./NewUtente.vue?vue&type=script&lang=js&"
export * from "./NewUtente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports